export const HROC_CHECKLIST_FORM_WIDTH_IN_PX = '632px'
